export const idlFactory = ({ IDL }) => {
  const ScanStatus = IDL.Variant({
    'Failed' : IDL.Text,
    'Scheduled' : IDL.Null,
    'Running' : IDL.Null,
    'Cancelled' : IDL.Null,
    'Completed' : IDL.Null,
  });
  const Device = IDL.Record({
    'id' : IDL.Text,
    'os' : IDL.Opt(IDL.Text),
    'cpu' : IDL.Opt(IDL.Text),
    'memory' : IDL.Opt(IDL.Text),
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'device_type' : IDL.Text,
    'last_seen' : IDL.Nat64,
    'services' : IDL.Vec(IDL.Text),
    'ip_address' : IDL.Text,
  });
  const DiscoverySession = IDL.Record({
    'id' : IDL.Text,
    'status' : ScanStatus,
    'discovered_devices' : IDL.Vec(Device),
    'error_message' : IDL.Opt(IDL.Text),
    'progress' : IDL.Nat32,
    'target_ranges' : IDL.Vec(IDL.Text),
    'scan_types' : IDL.Vec(IDL.Text),
    'credentials_username' : IDL.Opt(IDL.Text),
    'network_scan_enabled' : IDL.Bool,
    'completed_at' : IDL.Opt(IDL.Nat64),
    'scanned_ips' : IDL.Nat32,
    'started_at' : IDL.Nat64,
    'total_ips_to_scan' : IDL.Nat32,
  });
  return IDL.Service({
    'get_latest_scan' : IDL.Func([], [IDL.Opt(IDL.Record({}))], ['query']),
    'get_network_scan_results' : IDL.Func(
        [IDL.Text],
        [IDL.Opt(DiscoverySession)],
        ['query'],
      ),
    'get_recent_sessions' : IDL.Func(
        [IDL.Nat64],
        [IDL.Vec(IDL.Record({}))],
        ['query'],
      ),
    'ping_host' : IDL.Func(
        [IDL.Text],
        [IDL.Variant({ 'Ok' : IDL.Bool, 'Err' : IDL.Text })],
        [],
      ),
    'scan_ports' : IDL.Func(
        [IDL.Text, IDL.Vec(IDL.Nat16)],
        [IDL.Variant({ 'Ok' : IDL.Vec(IDL.Nat16), 'Err' : IDL.Text })],
        [],
      ),
    'start_discovery_scan' : IDL.Func(
        [IDL.Vec(IDL.Text), IDL.Vec(IDL.Text)],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'start_network_scan' : IDL.Func(
        [],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
